import React from "react";
import { Icon, Divider, Header, Progress, Segment, Statistic, Label, Card } from "semantic-ui-react";
import { dateDiff, getFormattedTimeFromMinutes } from "utils/dateUtils";
import Grid from "../../../node_modules/semantic-ui-react/dist/commonjs/collections/Grid/Grid";

// const _tvsecContainer = (status) => ({
//     height: 40,
// 	backgroundColor: '#43b39e',
// 	width: '100%',
// 	position: 'relative',
// 	padding: 10,
// 	display: 'flex',
// 	borderRadius: '4px 4px 0 0',
// 	marginTop: '5px',
// 	boxShadow: '0px 9px 35px -23px rgba(148,148,148,1)',

// });

const DashboardTV = ({ stats, onClose }) => {
	const getAvailableSecretaries = () => {
		return stats && stats.secretaries
			? stats.secretaries.filter((s) => s.assignedHelpFolders.length === 0 && s.openedFolders.length === 0 && s.help_nurse)
			: [];
	};
	const getAssignedSecretaries = () => {
		return stats && stats.secretaries
			? stats.secretaries.filter((s) => s.assignedHelpFolders.length !== 0 && s.openedFolders.length === 0 && s.help_nurse)
			: [];
	};
	const getBusySecretaries = () => {
		return stats && stats.secretaries ? stats.secretaries.filter((s) => s.openedFolders.length !== 0 && !s.tracing.center) : [];
	};
	const getPausedSecretaries = () => {
		return stats && stats.secretaries
			? stats.secretaries.filter((s) => s.assignedHelpFolders.length === 0 && s.openedFolders.length === 0 && !s.help_nurse && !s.tracing.center)
			: [];
	};
	const getNeedHelpSecretaries = () => {
		return stats && stats.secretaries ? stats.secretaries.filter((s) => s.need_help) : [];
	};
	return (
		<div style={{ width: "100%", height: "100%", margin: "3%" }}>
			<>
				<Grid>
					<Grid.Row>
						<Grid.Column computer={8}>
							<Divider horizontal style={{ margin: "50px 0" }}>
								<Header as="h1">
									<Icon name="list" /> File d'attente
								</Header>
							</Divider>
							<Segment.Group compact horizontal>
								<Segment style={{ minHeight: "168px" }}>
									<Statistic color="black" size="huge">
										<Statistic.Value> {stats && stats.init ? stats.init.min2 : 0}</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}>
											<Icon name="print" />
										</Statistic.Label>
									</Statistic>
								</Segment>
								<Segment>
									<Statistic color="green" size="huge">
										<Statistic.Value>
											{" "}
											{stats && stats.waiting ? stats.waiting.min2 : 0}{" "}
											{stats && stats.processed && stats.processed.min2 > 0 ? ` - ${stats.processed.min2}` : ""}
										</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}> &lt; 2 min</Statistic.Label>
									</Statistic>
								</Segment>
								<Segment>
									<Statistic color="orange" size="huge">
										<Statistic.Value>
											{" "}
											{stats && stats.waiting ? stats.waiting.between210 : 0}{" "}
											{stats && stats.processed && stats.processed.between210 > 0 ? `- ${stats.processed.between210}` : ""}
										</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}> 2 - 10 min</Statistic.Label>
									</Statistic>
								</Segment>
								<Segment>
									<Statistic color="red" size="huge">
										<Statistic.Value>
											{" "}
											{stats && stats.waiting ? stats.waiting.more10 : 0}
											{stats && stats.processed && stats.processed.more10 > 0 ? ` - ${stats.processed.more10}` : ""}
										</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}> &gt; 10 min</Statistic.Label>
									</Statistic>
								</Segment>
							</Segment.Group>
						</Grid.Column>
						<Grid.Column computer={8}>
							<Divider horizontal style={{ margin: "50px 0" }}>
								<Header as="h1">
									<Icon name="tachometer alternate" />
									Chiffres du jour
								</Header>
							</Divider>
							<Segment.Group compact horizontal>
								<Segment style={{ minHeight: "168px" }}>
									<Statistic size="huge">
										<Statistic.Value> {stats.totalFoldersCreatedToday}</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}> Créés</Statistic.Label>
									</Statistic>
								</Segment>
								<Segment>
									<Statistic size="huge">
										<Statistic.Value> {stats.totalFoldersNotDoneToday}</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}> En cours</Statistic.Label>
									</Statistic>
								</Segment>
								<Segment>
									<Statistic size="huge">
										<Statistic.Value> {stats.totalFoldersDoneToday}</Statistic.Value>
										<Statistic.Label style={{ fontSize: "2rem" }}> Traités</Statistic.Label>
									</Statistic>
								</Segment>

								<Segment style={{ width: "128px" }}>
									<Statistic.Group horizontal>
										<Statistic size="tiny">
											<Statistic.Label> Annulés par une secrétaire</Statistic.Label>
											<Statistic.Value> {stats.totalFoldersCanceledBySecToday}</Statistic.Value>
										</Statistic>
										<Statistic size="tiny">
											<Statistic.Label> Annulés par une préleveuse</Statistic.Label>
											<Statistic.Value> {stats.totalFoldersCanceledToday}</Statistic.Value>
										</Statistic>
									</Statistic.Group>
								</Segment>
							</Segment.Group>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column computer={16}>
							<Divider horizontal style={{ margin: "50px 0" }}>
								<Header as="h1">
									<Icon name="chart line" />
									Statut
								</Header>
							</Divider>

							<div style={{ marginTop: "50px" }}>
								<Progress percent={Math.round(stats.progress)} progress indicating></Progress>
							</div>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column computer={16}>
							<Divider horizontal style={{ margin: "50px 0" }}>
								<Header as="h1">
									<Icon name="street view" />
									Secrétaires
								</Header>
							</Divider>

							<Card.Group centered>
								<Card color="red">
									<Card.Content>
										<Card.Header textAlign="center">
											<Statistic color={getNeedHelpSecretaries().length > 0 ? "red" : "black"}>
												<Statistic.Value>
													<Icon name="question" />
													{getNeedHelpSecretaries().length}
												</Statistic.Value>
												<Statistic.Label style={{ fontSize: "2rem" }}>Besoin d'aide</Statistic.Label>
											</Statistic>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Label.Group color="red" size="big">
											{getNeedHelpSecretaries().map((sec) => (
												<Label>
													{sec.first_name} {sec.last_name} {sec.secretary_level === "SENIOR" ? <Icon name="star" color="yellow" /> : ""}
												</Label>
											))}
										</Label.Group>
									</Card.Content>
								</Card>
								<Card color="orange">
									<Card.Content>
										<Card.Header textAlign="center">
											<Statistic>
												<Statistic.Value>
													{" "}
													<Icon name="pause" />
													{getPausedSecretaries().length}
												</Statistic.Value>
												<Statistic.Label style={{ fontSize: "2rem" }}>Désactivées</Statistic.Label>
											</Statistic>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Label.Group color="grey" size="big">
											{getPausedSecretaries().map((sec) => (
												<Label>
													{sec.first_name} {sec.last_name} {sec.secretary_level === "SENIOR" ? <Icon name="star" color="yellow" /> : ""}
												</Label>
											))}
										</Label.Group>
									</Card.Content>
								</Card>

								<Card color="green">
									<Card.Content>
										<Card.Header textAlign="center">
											<Statistic>
												<Statistic.Value>
													{" "}
													<Icon name="check" />
													{getAvailableSecretaries().length}
												</Statistic.Value>
												<Statistic.Label style={{ fontSize: "2rem" }}>Disponibles</Statistic.Label>
											</Statistic>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Label.Group color="green" size="big">
											{getAvailableSecretaries().map((sec) => (
												<Label>
													{sec.first_name} {sec.last_name} {sec.secretary_level === "SENIOR" ? <Icon name="star" color="yellow" /> : ""}
												</Label>
											))}
										</Label.Group>
									</Card.Content>
								</Card>

								<Card color="brown">
									<Card.Content>
										<Card.Header textAlign="center">
											<Statistic>
												<Statistic.Value>
													{" "}
													<Icon name="bell" />
													{getAssignedSecretaries().length}
												</Statistic.Value>
												<Statistic.Label style={{ fontSize: "2rem" }}>Assignées</Statistic.Label>
											</Statistic>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Label.Group color="orange" size="big">
											{getAssignedSecretaries().map((sec) => (
												<Label>
													{sec.first_name} {sec.last_name} {sec.secretary_level === "SENIOR" ? <Icon name="star" color="yellow" /> : ""}
												</Label>
											))}
										</Label.Group>
									</Card.Content>
								</Card>

								<Card color="grey">
									<Card.Content>
										<Card.Header textAlign="center">
											<Statistic>
												<Statistic.Value>
													{" "}
													<Icon name="edit" />
													{getBusySecretaries().length}
												</Statistic.Value>
												<Statistic.Label style={{ fontSize: "2rem" }}>Occupées</Statistic.Label>
											</Statistic>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Label.Group color="black" size="big">
											{getBusySecretaries().map((sec) => (
												<Label>
													{sec.first_name} {sec.last_name} {sec.secretary_level === "SENIOR" ? <Icon name="star" color="yellow" /> : ""}
												</Label>
											))}
										</Label.Group>
									</Card.Content>
								</Card>
							</Card.Group>
						</Grid.Column>
					</Grid.Row>
				</Grid>

				{/* <Card.Group centered>
		<Card color='red'>
			<Card.Content>
				<Card.Header textAlign='center'>
					<Icon name='wait' color='red'/> En attente
				</Card.Header>
			</Card.Content>
			<Card.Content>
				<Segment.Group compact horizontal>
				<Segment >
				<Statistic color='green'  size='huge'>
						<Statistic.Value> {stats && stats.waiting ? stats.waiting.min2 : 0}</Statistic.Value>
						<Statistic.Label> &lt; 2 min</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment  >
				<Statistic color='orange'  size='huge'>
						<Statistic.Value> {stats && stats.waiting ? stats.waiting.between210 : 0}</Statistic.Value>
						<Statistic.Label> 2 - 10 min</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment >
				<Statistic color='red'  size='huge'>
						<Statistic.Value> {stats && stats.waiting ? stats.waiting.more10 : 0}</Statistic.Value>
						<Statistic.Label> &gt; 10 min</Statistic.Label>
					</Statistic>
				</Segment>
				</Segment.Group>
			</Card.Content>
			</Card>
			<Card color='grey'>
			<Card.Content>
				<Card.Header textAlign='center'>
					<Icon name='edit' /> En traitement
				</Card.Header>
			</Card.Content>
			<Card.Content>
				<Segment.Group compact horizontal>
				<Segment >
				<Statistic color='green'  size='huge'>
						<Statistic.Value> {stats && stats.processed ? stats.processed.min2 : 0}</Statistic.Value>
						<Statistic.Label> &lt; 2 min</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment  >
				<Statistic color='orange'  size='huge'>
						<Statistic.Value> {stats && stats.processed ? stats.processed.between210 : 0}</Statistic.Value>
						<Statistic.Label> 2 - 10 min</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment >
				<Statistic color='red'  size='huge'>
						<Statistic.Value> {stats && stats.processed ? stats.processed.more10 : 0}</Statistic.Value>
						<Statistic.Label> &gt; 10 min</Statistic.Label>
					</Statistic>
				</Segment>
				</Segment.Group>
			</Card.Content>
			</Card>
			<Card color='grey'>
			<Card.Content>
				<Card.Header textAlign='center'>
					<Icon name='check' /> Chiffres du jour
				</Card.Header>
			</Card.Content>
			<Card.Content>
			<Segment.Group compact horizontal>
				<Segment >
					<Statistic  size='huge' >
						<Statistic.Value> {stats.totalFoldersCreatedToday}</Statistic.Value>
						<Statistic.Label> Créés</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment >
					<Statistic  size='huge'>
						<Statistic.Value> {stats.totalFoldersDoneToday}</Statistic.Value>
						<Statistic.Label> Traités</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment >
				<Statistic  size='huge'>
						<Statistic.Value> {stats.totalFoldersCanceledToday}</Statistic.Value>
						<Statistic.Label> Annulés</Statistic.Label>
					</Statistic>
				</Segment>
			</Segment.Group>
			</Card.Content>
			</Card>
			<Card color='grey'>
			<Card.Content>
				<Card.Header textAlign='center'>
					<Icon name='check' /> Temps moyen
				</Card.Header>
			</Card.Content>
			<Card.Content>
			<Segment.Group compact  style={{margin:'auto', display:'flex', justifyContent:'center' }}>
				<Segment >
					<Statistic  size='tiny' style={{margin:'auto', display:'flex', justifyContent:'center' }}>
						<Statistic.Value> {getFormattedTimeFromMinutes(stats.waitingTimeForNurse)}</Statistic.Value>
						<Statistic.Label style={{fontSize:'1.2em'}}> Pour l'infirmière</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment >
					<Statistic  size='tiny' style={{margin:'auto', display:'flex', justifyContent:'center' }}>
						<Statistic.Value> {getFormattedTimeFromMinutes(stats.waitingTimeBeforeSupport)}</Statistic.Value>
						<Statistic.Label style={{fontSize:'1.2em'}}> Avant prise en charge</Statistic.Label>
					</Statistic>
				</Segment>
				<Segment >
				<Statistic  size='tiny' style={{margin:'auto', display:'flex', justifyContent:'center' }}>
						<Statistic.Value> {getFormattedTimeFromMinutes(stats.waitingTimeSupport)}</Statistic.Value>
						<Statistic.Label style={{fontSize:'1.2em'}}> Prise en charge</Statistic.Label>
					</Statistic>
				</Segment>
			</Segment.Group>
			</Card.Content>
			</Card>
		</Card.Group> */}
			</>
		</div>
	);
};

export default DashboardTV;
